<div class="monitoring-search">
  <div class="monitoring-search__serials">
    <label
      class="lx-label"
      for="serials">
      Serial Numbers
    </label>
    <textarea
      id="serialNumbers"
      name="serialNumbers"
      type="text"
      [(ngModel)]="serialNumbers"></textarea>
  </div>

  <div class="monitoring-search__start">
    <label for="meeting-time">Start Date</label>

    <input
      id="start-date"
      name="start-date"
      type="datetime-local"
      [(ngModel)]="startDate" />
  </div>

  <div class="monitoring-search__end">
    <label for="meeting-time">End Date</label>

    <input
      id="end-date"
      name="end-date"
      type="datetime-local"
      [(ngModel)]="endDate" />
  </div>

  <dcc-loading-indicator *ngIf="isLoading"></dcc-loading-indicator>

  <div
    *ngIf="!isLoading"
    class="monitoring-search__monitoring-search">
    <button
      class="lx-btn lx-btn-primary"
      id="deviceMonitoring"
      (click)="searchTimeline()">
      Search
    </button>
  </div>

  <div class="monitoring-search__monitoring-share">
    <button
      class="monitoring-search__monitoring-share__share lx-btn-small lx-btn-text"
      id="sharelink"
      [disabled]="!isTimelineSearched"
      (click)="shareLink()">
      <i class="lx-icon lx-share"></i>
      <div class="monitoring-search__button-text">Share</div>
    </button>
  </div>
</div>
